<template>
    <v-layout class="fill-height">
    <v-container
        id="contentDashboard" fluid
        class="fill-height"
    >
      
        <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        app
        >
        {{snackbarText}}
        <v-btn
            text
            dark
            @click="snackbar = false"
        >
            Fermer
        </v-btn>
        </v-snackbar>
        <v-layout>
        <v-row
            align="start"
            justify="start"
        >
            <v-col cols="12" class="pt-1">
            <header-sidebar></header-sidebar>
            <v-dialog v-model="changePasswordDialog" v-if="changePasswordDialog" max-width="480" min-height="400">
              <change-pwd v-on:print_message="printMessage" :user="user" @hide="changePasswordDialog = false"></change-pwd>
            </v-dialog>
            <v-dialog v-model="newUserDialog" v-if="newUserDialog" max-width="480" min-height="400">
              <new-user v-on:reloadData="reloadData" v-on:print_message="printMessage" @hide="newUserDialog = false"></new-user>
            </v-dialog>
            <v-dialog v-model="editUserDialog" v-if="editUserDialog" max-width="480" min-height="400">
              <edit-user v-on:reloadData="reloadData" :user="user" v-on:print_message="printMessage" @hide="editUserDialog = false"></edit-user>
            </v-dialog>

            <v-dialog v-model="unlinkDialog" v-if="unlinkDialog" max-width="480">
              <unlink :user="user" v-on:reloadData="reloadData"  @hide="unlinkDialog = false"></unlink>
            </v-dialog>
            <v-dialog v-model="linkDialog" v-if="linkDialog" max-width="480">
              <link-agent :user="user" v-on:reloadData="reloadData"  @hide="linkDialog = false"></link-agent>
            </v-dialog>
            <v-card class="table-content">
                <v-card-title>
                    <div class="text-left">
                        <span style="font-weight:700; font-size: 18px;">Gestion Utilisateurs</span>
                    </div>
                <v-spacer></v-spacer>
                <v-btn style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px;" depressed small color="primary" v-if="userdata.permission == 1" :to="{name:'usersPrivilege'}">Gestion des Privilèges</v-btn>
                <v-btn style="float:right; background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); margin-right:10px;" depressed small color="primary" @click="newUser">Nouveau</v-btn>
                </v-card-title>
                <v-card-text class="text-left">
                    <v-data-table
                        :headers="headers" 
                        :items="users"
                    >
                      <template v-slot:[`item.agent`]="props">
                        <v-list-item
                        >
                          <v-list-item-avatar v-if="props.item.agent">
                            <v-img :src="$baseURL + 'uploads/'+ props.item.agent.picture_url"></v-img>
                          </v-list-item-avatar>

                          <v-list-item-content v-if="props.item.agent">
                            <v-list-item-title v-html="props.item.agent.nom"></v-list-item-title>
                            <v-list-item-subtitle v-html="props.item.agent.titre_pro"></v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-content v-else>
                            <v-list-item-title>Aucun agent n'est associé à ce compte.</v-list-item-title>
                          </v-list-item-content>


                          <v-list-item-action>
                              <v-tooltip v-if="!props.item.agent" left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    icon
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="associate(props.item)"
                                  >
                                    <v-icon>mdi-link-variant</v-icon>
                                  </v-btn>
                                </template>
                                <span>Associer un agent</span>
                              </v-tooltip>
                              <v-tooltip v-else left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-bind="attrs"
                                    v-on="on"
                                    icon
                                    color="error"
                                    @click="dissociate(props.item)"
                                  >
                                    <v-icon>mdi-link-variant-off</v-icon>
                                  </v-btn>
                                </template>
                                <span>Dissocier l'agent</span>
                              </v-tooltip>
                            </v-list-item-action>
                        </v-list-item>
                      </template>
                      <template v-slot:[`item.actions`]="props">
                        <div class="text-center">
                          <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                icon
                                v-bind="attrs"
                                v-on="on"
                              >
                                <v-icon>mdi-dots-vertical</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item
                                @click="singleUser(props.item.id)"
                              >
                                <v-list-item-title><b>Voir</b></v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="editUser(props.item)"
                              >
                                <v-list-item-title><b>Editer</b></v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="changePassword(props.item)"
                              >
                                <v-list-item-title><b>Changer le mot de passe</b></v-list-item-title>
                              </v-list-item>
                              <v-list-item
                                @click="deleteUser(props.item.id)"
                                :disabled="props.item.permission == 1"
                              >
                                <v-list-item-title><b>Supprimer</b></v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </div>
                      </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
            </v-col>
        </v-row>
        </v-layout>
    </v-container>
    </v-layout>

</template>
    
<script>
  import headerSidebar from '../commons/header_sidebar.component'
  import changePwd from './actions/change_pwd'
  import newUser from './actions/new'
  import editUser from './actions/edit'
  import unlink from './actions/unlink'
  import linkAgent from './actions/link'
  import VueJwtDecode from "vue-jwt-decode"
  export default {
      name: 'listing-users',
      components: { headerSidebar, changePwd, newUser, editUser, unlink, linkAgent },
      data: () => ({
          snackbar: false,
          color: 'error',
          snackbarText: '',
          password: '',
          confirm_password: '',
          changePasswordDialog: false,
          newUserDialog: false,
          unlinkDialog: false,
          editUserDialog: false,
          linkDialog: false,
          userId: null,
          user: {},
          headers: [
              {text: 'Nom d\'utilisateur', value: 'username'},
              {text: 'Adresse Email', value: 'email'},
              {text: 'Agent Associé', value: 'agent'},
              {text: 'Privilège', value: 'permission_class'},
              {text: 'Actions', value: 'actions', align:'center', sortable: false},
          ],
          userdata: {},
          rules: {
              required: value => !!value || 'Ce champs est obligatoire.',
              password: value => value.length >= 8 || 'Le mot de passe doit contenir au moins 8 caractères.',
          },
          users: []
      }),
      mounted() {
          this.reloadData()
          this.userdata = Object.assign(VueJwtDecode.decode(this.$store.getters.getUser).userData, {agent: {}})
      },
      methods: {
        printMessage(data){
          this.reloadData()
          this.snackbarText = data.text
          this.color = data.color
          this.snackbar = true 
        },
        reloadData(){
          this.axios
            .get('/users/listing')
            .then(response => {
              this.axios
                  .get('/agent/listing')
                  .then(res =>
                    {
                      let agentList = res.data
                      response.data.forEach((item, key) => {
                        if(item.agent_id > 0){
                          response.data[key].agent = agentList.filter(v => { return v.id === item.agent_id } )[0]
                        }
                      })
                      this.users = response.data
                    })

              
            })
        },
        newUser(){
          this.newUserDialog = true
        },
        singleUser(param){
          console.log(param)
        },
        editUser(param){
          this.user = param
          this.editUserDialog = true
        },
        changePassword(param){
          this.user = param
          this.changePasswordDialog = true
        },
        deleteUser(param){
          if(confirm('Êtes-vous sûr de bien vouloir supprimer cet utilisateur?')){
            this.axios
              .delete("/user/"+param+"/delete")
              .then(res => {
                if(res.data.error == false){
                  this.printMessage({
                    text: 'Utilisateur supprimé avec succès.',
                    color: 'success'
                  })
                }
              })
          }
          
        },
        associate(user){
          this.user = user
          this.linkDialog = true
        },
        dissociate(user){
          this.user = user
          this.unlinkDialog = true
        }
      }
  } 
</script>


<style lang="scss" scoped>
 .privilege-checkbox >>> .v-label {
     font-size:12px;
 }
 .v-data-table >>> .text-start{
    height:65px !important
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table th{
    min-height: 325px !important;
  }
</style>


// WEBPACK FOOTER //
// src/views/dashboard/users/listing.vue